import React, { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { Theme } from '@mui/material/styles';

export interface PageTitleProps {
    children: ReactNode;
    buttons?: ReactNode;
    sx?: SystemStyleObject<Theme>;
}

const PageTitle: React.FC<PageTitleProps> = ({
    children,
    buttons,
    sx = {},
}) => {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            sx={{
                mb: 2,
                mr: 1,
                pl: { xs: 2, md: 0 },
                pr: { xs: 1, md: 0 },
                '&': sx,
            }}
        >
            <Typography
                sx={{
                    mb: 1,
                    fontWeight: 700,
                    color: '#C0C4CE',
                    whiteSpace: 'nowrap',
                    fontSize: { xs: '14px', md: '24px' },
                    lineHeight: { xs: '36px', md: '32px' },
                }}
                variant="h5"
            >
                {children}
            </Typography>
            {buttons && <Box>{buttons}</Box>}
        </Stack>
    );
};

export default React.memo(PageTitle);
